export const NO_PRICE_PLACEHOLDER = '*******';
